
import React, { Component } from 'react'
import axios from 'axios'


const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
class Clearcart extends Component {
	constructor(props) {
		super(props)

	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()
		console.log(this.state)
        const requestBody = {
            // getting user input 
            userid: loggedInUserID,
          };
		axios
			.delete(`https://shoppee-clone.herokuapp.com/user/${loggedInUserID}/cartitem/`, requestBody,  {
                headers: { 'Content-Type': 'application/json' }
              })
			.then(response => {
				console.log(response)
                window.location.reload();

			})
			.catch(error => {
       
				console.log(error)
			})
	}

	render() {
		
		return (
            <div>
            <fieldset class="w-100 col-12 mt-5 d-flex justify-content-around">
            <form  onSubmit={this.submitHandler} action="" method="delete">
              <button class="btn btn-danger button2" id="checkingout">
               Clear Cart <i class="bi bi-cart-x"></i>
              </button>
          </form>
          </fieldset>
          </div>
          
		)
	}
}

export default Clearcart

